// Social Media Platform URLs
export const YOUTUBE_URL = "https://www.youtube.com/watch?v=";
export const FACEBOOK_URL = "https://www.facebook.com/watch?v=";
export const LINKEDIN_URL = "https://www.linkedin.com/feed/update/";
export const TWITTER_URL = "https://x.com/";
export const INSTAGRAM_URL = "https://www.instagram.com/instagram/p/";
export const DAILYMOTION_URL = "https://www.dailymotion.com/video/";
